const state = {
  isOpen: true
}
export const mutationTypes = {
  open: '[left sidebar] open',
  closed: '[left sidebar] closed'
}

const mutations = {
  [mutationTypes.open](state) {
    state.isOpen = true
  },

  [mutationTypes.closed](state) {
    state.isOpen = false
  }
}

export default {
  state,
  mutations
}
